<app-header />
<main id="main-content" class="main-content">
  <router-outlet />
</main>
<app-footer />
